import { SxProps } from '@mui/material';
import { ReactNode } from 'react';
import { Stack, StackProps } from 'src/components/Stack';

interface NestedContentAreaProps extends Omit<StackProps, 'sx'> {
  children: ReactNode;
  spacing?: number;
  extendedSx?: SxProps;
}

export const NestedContentArea = ({
  children,
  spacing = 3,
  extendedSx = {},
  ...props
}: NestedContentAreaProps) => (
  <Stack
    spacing={spacing}
    sx={{
      p: 2.5,
      borderLeft: 2,
      borderColor: 'primary.main',
      backgroundColor: 'action.hover',
      borderRadius: 1,
      ...extendedSx,
    }}
    {...props}
  >
    {children}
  </Stack>
);
